import actions from '../action/examine.js'
import CONSTANT from '../constant/examine.js'
import { getDistanceBetween2 } from '../util/function.js'
import _ from 'underscore'

export default {
  actions,
  state: {
    orderList: {
      list:[],
      total: 0
    },
    skuId: '',
    agencyList: [], // 机构列表
    scheduleList: [], // 排期列表
    reserveOrder: {}, //预约列表 list: [], orderStatus: 0
    reserveOrderDetail: {}, //预约详情
    selectedAgency: {}, // 选择机构信息
  },
  mutations: {
    setSelectedAgency(state, data) {
      state.selectedAgency = data
    },
    setExamineSkuId(state, skuId) {
      state.skuId = skuId
    },
    [CONSTANT.EXAMINE_ORDER_GET_ALL_SUCCESS] (state, data) {
      state.orderList.list = data.list
      state.orderList.total = data.page.total
      return state
    },
    [CONSTANT.EXAMINE_ORDER_GET_ALL_ERROR] (state, e) {
      state.orderList.list = []
      state.orderList.total = 0
      return
    },
    [CONSTANT.EXAMINE_ORDER_GET_ALL_EMPTY] (state) {
      state.orderList.list = []
      state.orderList.total = 0
      return state
    },

    [CONSTANT.EXAMINE_ORDER_GET_ALL_MORE_SUCCESS] (state, result) {
      state.orderList = { total: result.page.total, list: [...state.orderList.list, ...result.list]}
    },

    [CONSTANT.EXAMINE_AGENCY_GET_SUCCESS] (state, data) {
      const position = this.getters.getGPSPostion
      const list = _.chain(data.list)
        .map((item) => {
          const distance = getDistanceBetween2(
            `${item.latitude}:${item.longitude}`,
            `${position.latitude}:${position.longitude}`
          );
          return { ...item, distance }
        })
        .sortBy(item => parseFloat(item.distance))
        .value()
      state.agencyList = [...list]
    },
    [CONSTANT.EXAMINE_AGENCY_GET_ERROR] (state, data) {
      state.agencyList = []
    },
    [CONSTANT.EXAMINE_AGENCY_GET_SCHEDULE_SUCCESS] (state, data) {
      state.scheduleList = data.list
      // state.scheduleList = data.list.filter(v => v.status === 1) // 筛选可预约日期 status: 1-可约 2-不可约 3-已约
    },
    [CONSTANT.EXAMINE_AGENCY_GET_SCHEDULE_ERROR] (state, data) {
      state.scheduleList = []
    },

    [CONSTANT.EXAMINE_RESERVE_GET_ORDER_LIST_SUCCESS] (state, data) {
      state.reserveOrder = data
    },
    [CONSTANT.EXAMINE_RESERVE_GET_ORDER_LIST_ERROR] (state, data) {
      state.reserveOrder = {list: [], orderStatus: 0}
    },

    [CONSTANT.EXAMINE_RESERVE_GET_ORDER_SUCCESS] (state, data) {
      state.reserveOrderDetail = data
    },
    [CONSTANT.EXAMINE_RESERVE_GET_ORDER_ERROR] (state, data) {
      state.reserveOrderDetail = {}
    },
    [CONSTANT.EXAMINE_GET_EXAMINER_LIST_SUCCESS] (state, data) {

    },

  },
  getters: {}
}
